module.exports = __webpack_public_path__ + "img/2.723ae6a1.jpg";